import React, { useState } from 'react'
import Logo from '../../Logo/Logo'
import { HamburgerIcon } from './HamburgerIcon'
import { MobileLinks } from './MobileLinks'
import { Link } from '../../global'

import '../navigation.scss'
import './hamburgerMenu.scss'

/**
 * Renders a mobile navigation menu based on the provided menu data.
 *
 * @param {Array} menu - An array of menu items with labels, URLs, and child items.
 * @returns {Array} An array of React components for the mobile navigation menu.
 */

const filterMenu = (menu, id) => {
  if (id === 'dGVybToxMjk5MQ==') {
    return menu.filter((item, index) => index !== 0)
  }
  return menu
}

const filterAndRenderMobileLinks = (menu, id) => {
  const filteredMenu = filterMenu(menu, id)

  return filteredMenu.map(
    item =>
      !item.parentId && (
        <MobileLinks
          key={item.id}
          url={item.path}
          label={item.label}
          subMenu={item.childItems.nodes}
        />
      ),
  )
}

/**
 * Represents a mobile hamburger menu component.
 *
 * @param {Array} props.menu - An array of main menu items.
 * @param {Array} props.secondaryMenu - An array of secondary menu items.
 * @param {function} props.setIsAccordionOpen - A function to set the accordion open status.
 * @returns {JSX.Element} A React component for the mobile hamburger menu.
 */

const HamburgerMenu = ({ menu, secondaryMenu, setIsAccordionOpen, logoSrc, homePath, pageContext}) => {
  const [isMenuOpen, isMenuOpenStatus] = useState()
  const { id } = pageContext || {}
  const linkTo = homePath || '/' 

  return (
    <>
      <div className={`burger-wrapper ${isMenuOpen && 'open'}`}>
        <div className="mobile-nav-inner">
          <div className={`burger-top ${isMenuOpen && 'open'}`}>
            <Link to={linkTo} style={{ lineHeight: 0, paddingTop: '4px' }}>
              <Logo src={logoSrc} height="28px" />
            </Link>
            <HamburgerIcon
              onClick={() => {
                isMenuOpenStatus(!isMenuOpen)
                setIsAccordionOpen(!isMenuOpen)
              }}
              open={isMenuOpen}
            />
          </div>
        </div>
        {isMenuOpen && (
          <div className="menu">
           {filterAndRenderMobileLinks(menu, id)}
            {filterAndRenderMobileLinks(secondaryMenu)}
          </div>
        )}
      </div>
    </>
  )
}

export default HamburgerMenu
